import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { GeriooxLogo } from "@/Icons/img/index";
import {
	IconIonicIosClose,
	IconFeatherUser,
	IconFeatherChevronRight,
} from "@/Icons/img/index";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container } from "./styles";

const Header = () => {
	const [mobile, setMobile] = useState(false);

	function toggleLogin() {
		const menuLogin = document.querySelector(".menu-sigin");
		menuLogin.classList.toggle("show");
	}

	return (
		<Container id='header'>
			<div className='container-fluid'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-11'>
						<header className='header'>
							<Link className='logo' to={`${process.env.PUBLIC_URL}/#welcome`}>
								<GeriooxLogo />
							</Link>

							<nav className='nav d-none d-lg-block'>
								<ul className='nav__list'>
									<li className='nav-item'>
										<Link
											to={`${process.env.PUBLIC_URL}/#register`}
											onClick={() => {
												setMobile(false);
											}}>
											Cadastro
										</Link>
									</li>
									<li className='nav-item'>
										<Link
											to={`${process.env.PUBLIC_URL}/#operation`}
											onClick={() => {
												setMobile(false);
											}}>
											Como funciona
										</Link>
									</li>
									<li className='nav-item'>
										<Link
											to={`${process.env.PUBLIC_URL}/regulamento`}
											onClick={() => setMobile(false)}>
											Regulamento
										</Link>
									</li>
									<li className='nav-item'>
										<Link
											to={`${process.env.PUBLIC_URL}/#stores-participants`}
											onClick={() => {
												setMobile(false);
											}}>
											Lojas participantes
										</Link>
									</li>
									<li className='nav-item'>
										<Link to={`${process.env.PUBLIC_URL}/sobre`}>Sobre Gerioox</Link>
									</li>
									<li className='nav-item'>
										<Link to={`${process.env.PUBLIC_URL}/contato`}>Contato</Link>
									</li>
								</ul>
							</nav>

							<div className='menu-icons'>
								<div className='link-profile'>
									<p onClick={toggleLogin}>Login</p>
									<ul className='menu-sigin'>
										<li>
											<Link
												to={`${process.env.PUBLIC_URL}/login/consumer`}
												onClick={toggleLogin}>
												Consumidor
											</Link>
										</li>
										<li>
											<Link
												to={`${process.env.PUBLIC_URL}/login/merchant`}
												onClick={toggleLogin}>
												Lojista
											</Link>
										</li>
									</ul>
								</div>

								<img
									loading='lazy'
									className='img-fluid icon d-lg-none'
									srcSet={`${
										require("@/assets/img/menu-mobile.png")
											.default
									} 320w, 
                                            ${
												require("@/assets/img/menu-mobile@2x.png")
													.default
											} 480w, 
                                            ${
												require("@/assets/img/menu-mobile@3x.png")
													.default
											} 800w`}
									src={
										require("@/assets/img/menu-mobile.png")
											.default
									}
									alt='icone menu'
									onClick={() => setMobile(true)}
								/>
							</div>
						</header>
					</div>
				</div>
			</div>
			<nav
				className='nav-mobile'
				style={{ display: mobile ? "block" : "none" }}>
				<div className='nav'>
					<button
						className='close-nav'
						onClick={() => setMobile(false)}>
						<IconIonicIosClose />
					</button>
					<ul className='nav__list'>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/#register`}
								onClick={() => {
									setMobile(false);
								}}>
								Cadastro
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/#operation`}
								onClick={() => {
									setMobile(false);
								}}>
								Como funciona
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/regulamento`}
								onClick={() => setMobile(false)}>
								Regulamento
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/#stores-participants`}
								onClick={() => {
									setMobile(false);
								}}>
								Lojas participantes
							</Link>
						</li>
						<li className='nav-item'>
							<Link to={`${process.env.PUBLIC_URL}/sobre`} onClick={() => setMobile(false)}>
								Sobre Gerioox
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/contato`}
								onClick={() => setMobile(false)}>
								Contato
							</Link>
						</li>
					</ul>
					<hr />
					<ul className='nav__list'>
						<li className='nav-item'>
							<span className='nav-item--spotligh'>
								<div>
									<IconFeatherUser />
									<span>Login</span>
								</div>
								<IconFeatherChevronRight />
							</span>
						</li>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/login/consumer`}
								onClick={() => setMobile(false)}>
								Consumidor
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								to={`${process.env.PUBLIC_URL}/login/merchant`}
								onClick={() => setMobile(false)}>
								Lojista
							</Link>
						</li>
					</ul>
				</div>
			</nav>
		</Container>
	);
};

export default Header;
